export const trackChatwootEvent = (eventName, properties = {}) => {
  try {
    if (!window.$chatwoot?.setCustomAttributes) return;
    window.$chatwoot.setCustomAttributes({
      last_event: eventName,
      last_event_at: new Date().toISOString(),
      ...properties,
    });
  } catch (e) {
    console.warn("Could not send event to Chatwoot:", e);
  }
};
